import { Box, Flex, Heading } from "@chakra-ui/react";
import Sidebar3 from "components/Sidebar3";
import WelcomeSection from "components/WelcomeSection";
import { useApi } from "hooks/useApi";
import { useAuthentication } from "hooks/useAuthentication";
import { useCache } from "hooks/useCache";
import { Helmet } from "react-helmet";
import MiniStatsSection from "./MiniStatsSection";
import QRCodeSection from "./QRCodeSection";
import TaxPaymentTable from "./TaxPaymentTable";

export default function TaxPayerDashboardPage() {
  const { getTaxReports } = useApi();
  const {user} = useAuthentication();
  const {
    data: report,
    isLoading,
  } = useCache("getTaxReports", () =>
    getTaxReports({})
  );
  
  return (
    <>
      <Helmet>
        <title>Codes QR Statistics - Origin360 Tracking and Reporting</title>
        <meta
          name="description"
          content="Monitor Code QR generation, reports, and product scans with Origin360. Get insights into counterfeit alerts and order trends for effective product tracking."
        />
      </Helmet>
      <Box bg="white" w="100%">
        <Box>
          <Flex>
            <Sidebar3 />
            <Flex
              gap="10px"
              bg="very_light_gray"
              flex={1}
              flexDirection="column"
              py="20px"
            >
              {/* welcome section */}
              <WelcomeSection />
              {!isLoading && (
                <Flex
                  gap="20px"
                  flexDirection="column"
                  alignItems="start"
                  mx={{ md: "22px", base: "0px" }}
                >
                  <Box>
                  <Heading size="xl" fontFamily="Arimo">
                    Bienvenue, {user?.user?.institution_name}
                  </Heading>
                  <Heading color={"GrayText"}  size="sm" fontFamily="Arimo">
                    Tableau de bord Débiteur
                  </Heading>
                  </Box>
                  <Flex w="100%" flexDirection="column">
                    {/* q r code section */}
                    <QRCodeSection/>
                  </Flex>
                  <></>
                  <Flex w="100%" flexDirection="column">
                    {/* q r code section */}
                    <MiniStatsSection
                      data={report?.report || {}}
                    />
                    <TaxPaymentTable/>
                  </Flex>
                </Flex>
              )}
            </Flex>
          </Flex>
        </Box>
      </Box>
    </>
  );
}
